import { jsx as t, jsxs as u, Fragment as I } from "react/jsx-runtime";
import { withManagedProps as j } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as p } from "@made-people/react-prop-guard";
import { logoBlueprint as pe, menuTriggerBlueprint as Se, cartTriggerBlueprint as ye, accountTriggerBlueprint as Ne, template1Styling as M, searchTriggerBlueprint as Ce, template2Styling as x, template3Styling as L, template4Styling as R, bareboneBlueprint as q, headerBarBlueprint as ke } from "./index-blueprint.es.js";
import { TRYLogo as we, BurgerIcon as Ie, CartIcon as je, UserIcon as xe, MagnifierIcon as Le, CrossIcon as Pe } from "@made-people/blueprint-icons";
import { useLink as O, useNavigate as Ae } from "@made-people/grease-link";
import k from "clsx";
import { buttonContentPropsSchema as Z, Button as U } from "@made-people/blueprint-button";
import { overlayEventEmitter as D } from "@made-people/blueprint-overlay";
import { useMemo as $, useState as P, useEffect as V, useRef as Be, useCallback as se } from "react";
import { useCartState as Ee } from "@made-people/grease-cart";
import { motion as ge, AnimatePresence as He } from "motion/react";
import { StickyWrapper as Q } from "@made-people/blueprint-sticky-wrapper";
import { searchInputSchema as de, SearchInput as be } from "@made-people/blueprint-search";
import { siteSettingsTriggerSchema as X, SiteSettingsTrigger as ee } from "@made-people/blueprint-site-settings";
import { Markdown as re } from "@made-people/blueprint-markdown";
import "@made-people/blueprint";
const A = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  svg: e.custom().optional(),
  className: e.string().optional()
}), F = p(
  {
    schema: A,
    defaultProps: {
      enabled: !0,
      svg: /* @__PURE__ */ t(we, {})
    }
  },
  ({ blueprint: l, variants: i, svg: g, enabled: c, className: r }) => {
    const n = O(), o = (l ?? pe).styles(i);
    return c ? /* @__PURE__ */ t("div", { className: k(o.wrapper, r), children: /* @__PURE__ */ t(n, { className: o.link, href: "", "aria-label": "Go to home", children: g }) }) : null;
  }
), J = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  overlayId: e.string().optional(),
  className: e.string().optional()
}), te = p(
  {
    schema: J,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Menu"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(Ie, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: i, enabled: g, className: c, ...r }) => {
    var o, s, d, b, h, f;
    const a = (l ?? Se).styles(i);
    return g === !1 ? null : /* @__PURE__ */ u(
      "div",
      {
        className: k(a.wrapper, c),
        onClick: () => D.emit("open", {
          overlayId: r.overlayId
        }),
        children: [
          !((o = r.button) != null && o.enabled) && /* @__PURE__ */ u(I, { children: [
            ((s = r.icon) == null ? void 0 : s.enabled) && /* @__PURE__ */ t("span", { className: a.icon, children: r.icon.iconSvg }),
            ((d = r.label) == null ? void 0 : d.enabled) && /* @__PURE__ */ t("span", { className: a.label, children: r.label.labelText })
          ] }),
          ((b = r.button) == null ? void 0 : b.enabled) && /* @__PURE__ */ t(
            U,
            {
              as: "span",
              label: ((h = r.label) == null ? void 0 : h.enabled) && r.label.labelText,
              iconLeft: ((f = r.icon) == null ? void 0 : f.enabled) && r.icon.iconSvg,
              ...r.button.settings
            }
          )
        ]
      }
    );
  }
), B = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  qtyDisplay: e.enum(["total_quantity", "total_items"]).optional(),
  animateQtyOnUpdate: e.boolean().optional(),
  type: e.enum(["mini-cart", "link-to-checkout"]).optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  className: e.string().optional()
}), G = p(
  {
    schema: B,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Cart"
      },
      type: "link-to-checkout",
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(je, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: i, enabled: g, type: c, className: r, ...n }) => {
    var C;
    const o = (l ?? ye).styles(i), { cart: s } = Ee(), d = O(), b = $(() => n.qtyDisplay === "total_items" ? s == null ? void 0 : s.items.length : s == null ? void 0 : s.items.reduce((T, v) => T + v.quantity, 0), [s, n.qtyDisplay]), [h, f] = P(b), [m, y] = P(!1);
    V(() => {
      if (h !== null && b !== h && n.animateQtyOnUpdate) {
        y(!0);
        const T = setTimeout(() => y(!1), 500);
        return f(b), () => clearTimeout(T);
      }
    }, [b]);
    const N = $(
      () => {
        var T, v, S;
        return /* @__PURE__ */ t(
          U,
          {
            as: c === "link-to-checkout" ? "a" : "button",
            link: c === "link-to-checkout" ? { href: "checkout" } : void 0,
            onClick: c === "mini-cart" ? () => D.emit("open", { overlayId: "mini-cart" }) : void 0,
            iconLeft: ((T = n.icon) == null ? void 0 : T.enabled) && n.icon.iconSvg,
            iconRight: /* @__PURE__ */ t(
              ce,
              {
                qty: b,
                className: o.counter,
                shouldAnimate: m
              }
            ),
            label: ((v = n.label) == null ? void 0 : v.enabled) && n.label.labelText,
            ...(S = n == null ? void 0 : n.button) == null ? void 0 : S.settings,
            className: r
          }
        );
      },
      [c, n.icon, n.label, o.counter, b, m]
    ), w = $(() => {
      var v, S;
      const T = /* @__PURE__ */ u(I, { children: [
        ((v = n.icon) == null ? void 0 : v.enabled) && /* @__PURE__ */ t("span", { className: o.icon, children: n.icon.iconSvg }),
        ((S = n.label) == null ? void 0 : S.enabled) && /* @__PURE__ */ t("span", { className: o.label, children: n.label.labelText }),
        /* @__PURE__ */ t(
          ce,
          {
            qty: b,
            className: o.counter,
            shouldAnimate: m
          }
        )
      ] });
      return c === "link-to-checkout" ? /* @__PURE__ */ t(
        d,
        {
          href: "checkout",
          className: k(o.wrapper, r),
          "aria-label": "Go to checkout",
          children: T
        }
      ) : /* @__PURE__ */ t(
        "button",
        {
          className: k(o.wrapper, r),
          onClick: () => D.emit("open", { overlayId: "mini-cart" }),
          children: T
        }
      );
    }, [c, n.icon, n.label, o, b, m]);
    return g ? (C = n.button) != null && C.enabled ? N : w : null;
  }
), ce = ({
  qty: l,
  className: i,
  shouldAnimate: g
}) => /* @__PURE__ */ t(
  ge.span,
  {
    className: i,
    animate: g ? { scale: [1, 0.9, 1.2, 0.8, 1] } : { scale: 1 },
    transition: {
      duration: 0.4,
      ease: "easeOut"
      // times: [0, 0.2, 0.6, 0.8, 1], // Custom timing for each keyframe
    },
    children: l
  }
), E = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  onClick: e.custom().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  className: e.string().optional(),
  href: e.string().optional(),
  action: e.enum(["drawer", "page"]).optional(),
  loggedIn: e.object({
    isLoggedIn: e.boolean().optional(),
    showInitials: e.boolean().optional(),
    label: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional()
  }).optional()
}), Y = p(
  {
    schema: E,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "My Account"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(xe, {})
      },
      button: {
        enabled: !1
      },
      loggedIn: {
        isLoggedIn: !1,
        showInitials: !0
      }
    }
  },
  ({ blueprint: l, variants: i, enabled: g, className: c, href: r, onClick: n, ...a }) => {
    var y, N, w, C, T, v, S, H, ne, ae, le, ie, oe;
    const s = (l ?? Ne).styles(i), d = Ae();
    if (g === !1 || r === void 0 && a.action !== "drawer")
      return null;
    const b = O(), h = (y = a.loggedIn) != null && y.showInitials ? Me(a.loggedIn.firstName, a.loggedIn.lastName) : "", f = a.action === "drawer" ? "button" : b, m = () => {
      a.action === "drawer" ? D.emit("open", { overlayId: "login-drawer" }) : d(r ?? "");
    };
    return /* @__PURE__ */ u(I, { children: [
      !((N = a.loggedIn) != null && N.isLoggedIn) && /* @__PURE__ */ u("div", { className: k(s.wrapper, c), children: [
        !((w = a.button) != null && w.enabled) && /* @__PURE__ */ u(
          f,
          {
            href: r ?? "",
            "aria-label": "Go to account",
            onClick: m,
            children: [
              ((C = a.icon) == null ? void 0 : C.enabled) && /* @__PURE__ */ t("span", { className: s.icon, children: a.icon.iconSvg }),
              ((T = a.label) == null ? void 0 : T.enabled) && /* @__PURE__ */ t("span", { className: s.label, children: a.label.labelText })
            ]
          }
        ),
        ((v = a.button) == null ? void 0 : v.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "button",
            onClick: m,
            iconLeft: ((S = a.icon) == null ? void 0 : S.enabled) && a.icon.iconSvg,
            label: ((H = a.label) == null ? void 0 : H.enabled) && a.label.labelText,
            ...a.button.settings
          }
        )
      ] }),
      ((ne = a.loggedIn) == null ? void 0 : ne.isLoggedIn) && /* @__PURE__ */ u("div", { className: k(s.wrapper, c), children: [
        !((ae = a.button) != null && ae.enabled) && /* @__PURE__ */ u(b, { href: r ?? "", children: [
          ((le = a.icon) == null ? void 0 : le.enabled) && /* @__PURE__ */ t("span", { className: s.icon, children: /* @__PURE__ */ t("span", { className: s.loggedInInitials, children: h }) }),
          a.loggedIn.label && /* @__PURE__ */ t("span", { className: s.label, children: a.loggedIn.label })
        ] }),
        ((ie = a.button) == null ? void 0 : ie.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "a",
            link: { href: r },
            iconLeft: ((oe = a.icon) == null ? void 0 : oe.enabled) && /* @__PURE__ */ t("span", { className: s.loggedInInitials, children: h }),
            label: a.loggedIn.label && a.loggedIn.label,
            ...a.button.settings
          }
        )
      ] })
    ] });
  }
);
function Me(l, i) {
  const g = (l == null ? void 0 : l[0]) ?? "", c = (i == null ? void 0 : i[0]) ?? "";
  return `${g}${c}`.toUpperCase();
}
const _ = e.union([
  e.literal("mobile"),
  e.literal("tablet"),
  e.literal("desktop"),
  e.literal("none"),
  e.array(e.enum(["mobile", "tablet", "desktop"]))
]).optional();
function z(l) {
  const i = {
    "data-screen-mobile": "hidden",
    "data-screen-tablet": "hidden",
    "data-screen-desktop": "hidden"
  };
  return l ? (Array.isArray(l) ? l : [l]).forEach((c) => {
    c === "mobile" ? i["data-screen-mobile"] = "visible" : c === "tablet" ? i["data-screen-tablet"] = "visible" : c === "desktop" && (i["data-screen-desktop"] = "visible");
  }) : (i["data-screen-mobile"] = "visible", i["data-screen-tablet"] = "visible", i["data-screen-desktop"] = "visible"), i;
}
const ue = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: A.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: J.optional().describe("Configure the Menu Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search
   */
  search: de.optional().describe("Configure the Search"),
  /**
   * Define visibility per breakpoint
   */
  visibility: _,
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional()
}), Re = j(
  "HeaderTemplate1",
  p(
    ue,
    ({
      variants: l,
      cartTrigger: i,
      menuTrigger: g,
      accountTrigger: c,
      menu: r,
      topbar: n,
      ...a
    }) => {
      const o = M.main.styles(l);
      return /* @__PURE__ */ u(
        Q,
        {
          className: o.wrapper,
          ...z(a == null ? void 0 : a.visibility),
          children: [
            n && n,
            /* @__PURE__ */ u("div", { className: o.nav, children: [
              /* @__PURE__ */ u("div", { className: o.left, children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    ...g,
                    blueprint: M.menuTrigger
                  }
                ),
                r && r,
                /* @__PURE__ */ t("div", { className: o.search, children: /* @__PURE__ */ t(be, { ...a.search }) })
              ] }),
              /* @__PURE__ */ t("div", { className: o.center, children: /* @__PURE__ */ t(F, { ...a.logo, blueprint: M.logo }) }),
              /* @__PURE__ */ u("div", { className: o.right, children: [
                /* @__PURE__ */ t(
                  Y,
                  {
                    ...c,
                    blueprint: M.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...i,
                    blueprint: M.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), W = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  /**
   * @property {string} [searchRoute] - An optional string representing the search route.
   */
  searchRoute: e.string().optional(),
  onStateChange: e.custom().optional(),
  icons: e.object({
    default: e.custom().or(e.literal(!1)).optional(),
    close: e.custom().or(e.literal(!1)).optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  className: e.string().optional()
}), K = p(
  {
    schema: W,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Search"
      },
      icons: {
        default: /* @__PURE__ */ t(Le, {}),
        close: /* @__PURE__ */ t(Pe, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: i, enabled: g, className: c, onStateChange: r, ...n }) => {
    var y, N;
    const o = (l ?? Ce).styles(i), s = O(), [d, b] = P(!1), h = d ? (y = n == null ? void 0 : n.icons) == null ? void 0 : y.close : (N = n == null ? void 0 : n.icons) == null ? void 0 : N.default;
    if (g === !1)
      return null;
    const f = () => {
      D.emit("open", { overlayId: "search-sidebar" });
    }, m = () => {
      var w, C, T, v, S, H;
      return /* @__PURE__ */ u(I, { children: [
        !((w = n.button) != null && w.enabled) && /* @__PURE__ */ u(I, { children: [
          ((C = n.icons) == null ? void 0 : C.default) && /* @__PURE__ */ t("span", { className: o.icon, children: h }),
          ((T = n.label) == null ? void 0 : T.enabled) && /* @__PURE__ */ t("span", { className: o.label, children: n.label.labelText })
        ] }),
        ((v = n.button) == null ? void 0 : v.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "span",
            label: ((S = n.label) == null ? void 0 : S.enabled) && n.label.labelText,
            iconLeft: ((H = n.icons) == null ? void 0 : H.default) && h,
            ...n.button.settings
          }
        )
      ] });
    };
    return /* @__PURE__ */ u(I, { children: [
      n.searchRoute && /* @__PURE__ */ t(
        s,
        {
          href: n.searchRoute,
          className: k(o.wrapper, c),
          children: m()
        }
      ),
      !n.searchRoute && /* @__PURE__ */ t(
        "span",
        {
          className: k(o.wrapper, c),
          onClick: f,
          children: m()
        }
      )
    ] });
  }
), me = e.object({
  variants: e.custom().optional(),
  logo: A.optional().describe("Configure the Logo"),
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  menuTrigger: J.optional().describe("Configure the Menu Trigger"),
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  searchTrigger: W.optional().describe("Configure the Search Trigger"),
  siteSettingsTrigger: X.optional(),
  visibility: _,
  menu: e.custom().optional(),
  topbar: e.custom().optional()
}), qe = j(
  "HeaderTemplate2",
  p(
    {
      schema: me,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: i,
      menuTrigger: g,
      accountTrigger: c,
      searchTrigger: r,
      siteSettingsTrigger: n,
      menu: a,
      topbar: o,
      ...s
    }) => {
      const d = x.main.styles(l), [b, h] = P(!1), f = Be(null), m = $(
        () => ({
          // Remove dynamic height calculations - let CSS handle it
          overflow: "hidden"
        }),
        []
      ), y = se((N) => {
        requestAnimationFrame(() => {
          h(N);
        });
      }, []);
      return /* @__PURE__ */ t(I, { children: /* @__PURE__ */ u(
        Q,
        {
          forwardedRef: f,
          className: d.wrapper,
          ...z(s == null ? void 0 : s.visibility),
          style: m,
          children: [
            o && o,
            /* @__PURE__ */ u("div", { className: d.nav, children: [
              /* @__PURE__ */ u("div", { className: d.left, children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    ...g,
                    blueprint: x.menuTrigger
                  }
                ),
                a && a,
                /* @__PURE__ */ t(
                  K,
                  {
                    ...r,
                    blueprint: x.searchTrigger,
                    onStateChange: y
                  }
                )
              ] }),
              /* @__PURE__ */ t("div", { className: d.center, children: /* @__PURE__ */ t(F, { ...s.logo, blueprint: x.logo }) }),
              /* @__PURE__ */ u("div", { className: d.right, children: [
                /* @__PURE__ */ t(
                  ee,
                  {
                    ...n,
                    className: d.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  Y,
                  {
                    ...c,
                    blueprint: x.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...i,
                    blueprint: x.cartTrigger
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ t(He, { mode: "wait", children: b && /* @__PURE__ */ t(
              ge.div,
              {
                className: "w-full z-30 px-component-spacing-sm pb-3",
                initial: { height: 0, opacity: 0 },
                animate: {
                  height: "auto",
                  opacity: 1,
                  transition: {
                    height: { duration: 0.3, ease: [0.19, 1, 0.22, 1] },
                    opacity: { duration: 0.2, delay: 0.1 }
                  }
                },
                exit: {
                  height: 0,
                  opacity: 0,
                  transition: {
                    height: { duration: 0.2, ease: "easeOut" },
                    opacity: { duration: 0.15 }
                  }
                },
                style: { overflow: "hidden" },
                children: /* @__PURE__ */ t(
                  be,
                  {
                    autoComplete: { enabled: !0 },
                    autoFocus: !0
                  }
                )
              }
            ) })
          ]
        }
      ) });
    }
  )
), he = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: A.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: J.optional().describe("Configure the Menu Trigger"),
  /**
   * Configure the Menu Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: W.optional().describe("Configure the Search Trigger"),
  /**
   * Define visibility per breakpoint
   */
  visibility: _,
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Add a separate sub bar component that renders below the nav
   */
  subBar: e.custom().optional()
}), Ue = j(
  "HeaderTemplate3",
  p(
    he,
    ({
      variants: l,
      cartTrigger: i,
      menuTrigger: g,
      accountTrigger: c,
      searchTrigger: r,
      menu: n,
      topbar: a,
      subBar: o,
      ...s
    }) => {
      const d = L.main.styles(l);
      return /* @__PURE__ */ u(
        Q,
        {
          className: d.wrapper,
          ...z(s == null ? void 0 : s.visibility),
          children: [
            a && a,
            /* @__PURE__ */ u("div", { className: d.nav, children: [
              /* @__PURE__ */ t("div", { className: d.left, children: /* @__PURE__ */ t(F, { ...s.logo, blueprint: L.logo }) }),
              /* @__PURE__ */ u("div", { className: d.right, children: [
                /* @__PURE__ */ t(
                  K,
                  {
                    ...r,
                    blueprint: L.searchTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  Y,
                  {
                    ...c,
                    blueprint: L.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...i,
                    blueprint: L.cartTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  te,
                  {
                    ...g,
                    blueprint: L.menuTrigger
                  }
                ),
                n && n
              ] })
            ] }),
            o && o
          ]
        }
      );
    }
  )
), fe = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Country Selector
   */
  siteSettingsTrigger: X.optional(),
  /**
   * Configure the Logo
   */
  logo: A.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: W.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Add a separate sub bar component that renders below the nav
   */
  subBar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: _,
  overlay: e.boolean().optional()
}), De = j(
  "HeaderTemplate4",
  p(
    {
      schema: fe,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: i,
      searchTrigger: g,
      accountTrigger: c,
      siteSettingsTrigger: r,
      menu: n,
      topbar: a,
      subBar: o,
      overlay: s,
      ...d
    }) => {
      const [b, h] = P(!1), f = se(() => {
        h(window.scrollY > 100);
      }, []);
      V(() => (window.addEventListener("scroll", f), () => {
        window.removeEventListener("scroll", f);
      }), []);
      const m = R.main.styles(l);
      return /* @__PURE__ */ u(
        Q,
        {
          className: m.wrapper,
          overlay: s,
          ...z(d == null ? void 0 : d.visibility),
          "data-scrolled": b,
          children: [
            a && a,
            /* @__PURE__ */ u("div", { className: m.nav, children: [
              /* @__PURE__ */ u("div", { className: m.left, children: [
                /* @__PURE__ */ t(F, { ...d.logo, blueprint: R.logo }),
                n && n
              ] }),
              /* @__PURE__ */ u("div", { className: m.right, children: [
                /* @__PURE__ */ t(
                  ee,
                  {
                    ...r,
                    className: m.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  K,
                  {
                    ...g,
                    blueprint: R.searchTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  Y,
                  {
                    ...c,
                    blueprint: R.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...i,
                    blueprint: R.cartTrigger
                  }
                )
              ] })
            ] }),
            o && o
          ]
        }
      );
    }
  )
), Te = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: A.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: W.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: _,
  siteSettingsTrigger: X.optional(),
  search: de.optional().describe("Configure the Search"),
  overlay: e.boolean().optional()
}), Oe = j(
  "HeaderBarebone",
  p(
    {
      schema: Te,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: i,
      searchTrigger: g,
      accountTrigger: c,
      siteSettingsTrigger: r,
      menu: n,
      topbar: a,
      search: o,
      overlay: s,
      ...d
    }) => {
      const b = q.main.styles(l), [h, f] = P(!1);
      return V(() => {
        const m = () => {
          f(window.scrollY > 100);
        };
        return window.addEventListener("scroll", m), () => {
          window.removeEventListener("scroll", m);
        };
      }, []), /* @__PURE__ */ u(
        Q,
        {
          className: b.wrapper,
          overlay: s,
          ...z(d == null ? void 0 : d.visibility),
          "data-scrolled": h,
          children: [
            a && a,
            /* @__PURE__ */ u("div", { className: b.nav, children: [
              /* @__PURE__ */ t(
                F,
                {
                  ...d.logo,
                  blueprint: q.logo,
                  className: b.logoPosition
                }
              ),
              n && /* @__PURE__ */ t("div", { className: b.menuPosition, children: n }),
              /* @__PURE__ */ t(
                ee,
                {
                  ...r,
                  className: b.siteSettingsTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                K,
                {
                  ...g,
                  blueprint: q.searchTrigger,
                  className: b.searchTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                Y,
                {
                  ...c,
                  blueprint: q.accountTrigger,
                  className: b.accountTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                G,
                {
                  ...i,
                  blueprint: q.cartTrigger,
                  className: b.cartTriggerPosition
                }
              )
            ] })
          ]
        }
      );
    }
  )
), ve = e.discriminatedUnion("template", [
  ue.extend({
    template: e.literal("template1")
  }),
  me.extend({
    template: e.literal("template2")
  }),
  he.extend({
    template: e.literal("template3")
  }),
  fe.extend({
    template: e.literal("template4")
  }),
  Te.extend({
    template: e.literal("barebone")
  })
]), Qe = p(ve, (l) => {
  switch (l.template) {
    case "template1":
      return /* @__PURE__ */ t(Re, { ...l });
    case "template2":
      return /* @__PURE__ */ t(qe, { ...l });
    case "template3":
      return /* @__PURE__ */ t(Ue, { ...l });
    case "template4":
      return /* @__PURE__ */ t(De, { ...l });
    case "barebone":
      return /* @__PURE__ */ t(Oe, { ...l });
    default:
      return null;
  }
}), Fe = "template2", Ge = e.object({
  settings: ve.optional()
}), gt = j(
  "Header",
  p({ schema: Ge, defaultProps: {} }, (l) => {
    const i = l.settings || { template: Fe };
    return /* @__PURE__ */ t(Qe, { ...i });
  })
), Ye = e.object({
  variants: e.custom().optional(),
  label: e.string().optional(),
  link: e.object({
    href: e.string().optional(),
    target: e.string().optional()
  }).optional()
}), _e = e.object({
  settings: Ye.optional()
}), dt = j(
  "HeaderBar",
  p(_e, ({ settings: l }) => {
    var c;
    const i = O(), g = ke.styles(l == null ? void 0 : l.variants);
    return l != null && l.label ? /* @__PURE__ */ t("div", { className: g.outer, children: /* @__PURE__ */ t("div", { className: g.wrapper, children: /* @__PURE__ */ t("div", { className: g.inner, children: (c = l.link) != null && c.href ? /* @__PURE__ */ t(i, { href: l.link.href, target: l.link.target, children: /* @__PURE__ */ t(re, { content: l.label, className: g.label }) }) : /* @__PURE__ */ t(re, { content: l.label, className: g.label }) }) }) }) : null;
  })
);
export {
  Y as AccountTrigger,
  G as CartTrigger,
  gt as Header,
  dt as HeaderBar,
  Oe as HeaderBarebone,
  F as Logo,
  te as MenuTrigger,
  K as SearchTrigger,
  Qe as SelectTemplate,
  Re as Template1,
  qe as Template2,
  Ue as Template3,
  De as Template4,
  E as accountTriggerSchema,
  Te as bareboneSchema,
  _ as breakpointsSchema,
  B as cartTriggerSchema,
  _e as headerBarPropsSchema,
  Ye as headerBarSchema,
  Ge as headerPropsSchema,
  ve as headerSchema,
  A as logoSchema,
  J as menuTriggerSchema,
  W as searchTriggerSchema,
  z as setBreakpointDataAttributes,
  ue as template1Schema,
  me as template2Schema,
  he as template3Schema,
  fe as template4Schema
};
//# sourceMappingURL=index.es.js.map
